import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { getPageStatus, PageLayout } from 'components/PageLayout';
import { PlaceForm } from 'components/PlaceForm';
import { Place } from 'features/places/places.types';
import { usePlaces } from 'features/places/hooks/usePlaces';
import { useLocationState } from 'hooks/useLocationState';
import { SimplePageLayout } from 'components/layouts/SimplePageLayout';
import { useReleaseFlag } from 'hooks/useReleaseFlags';

type ContentProps = {
  place: Place;
};

const Content = (props: ContentProps): JSX.Element => {
  const { place } = props;
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('editPlace.title')}</title>
      </Helmet>
      <SimplePageLayout>
        <PlaceForm initialPlace={place} />
      </SimplePageLayout>
    </>
  );
};

export const EditPlace = (
  props: RouteComponentProps<{ placeId: string }>,
): JSX.Element => {
  const {
    match: {
      params: { placeId },
    },
  } = props;
  const { t } = useTranslation();
  const { places, loading } = usePlaces();
  const { fromRoute } = useLocationState('/');
  const pinImprovements = useReleaseFlag('pin_drop_improvements');

  const place = places.find((p) => p.id === Number(placeId));

  const status = getPageStatus({
    isLoading: loading,
    isError: !place,
  });

  const readyAction = pinImprovements ? fromRoute : '/';

  return (
    <PageLayout
      data-cname="EditPlacePage"
      status={status}
      headerBarProps={{
        title: t('editPlace.title'),
        action: status === 'ready' ? readyAction : 'back',
      }}
    >
      {place && <Content place={place} />}
    </PageLayout>
  );
};
